import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelText as _vModelText, resolveDirective as _resolveDirective, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "space-y-4 flex min-h-0 flex-1 flex-col"
};
const _hoisted_2 = {
  class: "flex flex-wrap gap-1.5 rounded-xl bg-slate-100 p-1",
  "aria-label": "日报治理分类"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  key: 0,
  class: "flex min-h-0 flex-1 flex-col"
};
const _hoisted_5 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_6 = ["disabled"];
const _hoisted_7 = {
  class: "data-table-shell"
};
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col items-center gap-3 px-6 py-16 text-center"
};
const _hoisted_9 = {
  key: 1,
  class: "flex flex-col items-center gap-3 px-6 py-16 text-center"
};
const _hoisted_10 = {
  class: "flex h-12 w-12 items-center justify-center rounded-full bg-rose-100"
};
const _hoisted_11 = {
  key: 2,
  class: "flex flex-col items-center gap-3 px-6 py-16 text-center"
};
const _hoisted_12 = {
  class: "empty-state-icon"
};
const _hoisted_13 = {
  key: 3,
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_14 = {
  class: "data-table min-w-[1280px]"
};
const _hoisted_15 = {
  class: "data-table-body"
};
const _hoisted_16 = {
  class: "data-table-td font-medium text-slate-800"
};
const _hoisted_17 = {
  class: "data-table-td text-slate-700"
};
const _hoisted_18 = {
  class: "data-table-td text-slate-700"
};
const _hoisted_19 = {
  class: "data-table-td text-slate-700"
};
const _hoisted_20 = {
  class: "data-table-td"
};
const _hoisted_21 = {
  class: "data-table-td text-slate-700"
};
const _hoisted_22 = {
  class: "data-table-td text-slate-700"
};
const _hoisted_23 = {
  class: "data-table-td text-slate-700"
};
const _hoisted_24 = {
  class: "data-table-td text-slate-700"
};
const _hoisted_25 = {
  class: "data-table-td"
};
const _hoisted_26 = {
  key: 1,
  class: "grid gap-5 xl:grid-cols-[minmax(0,1fr)_minmax(320px,420px)]"
};
const _hoisted_27 = {
  class: "mt-4 space-y-4"
};
const _hoisted_28 = {
  class: "block"
};
const _hoisted_29 = {
  key: 0,
  class: "block"
};
const _hoisted_30 = {
  class: "form-label"
};
const _hoisted_31 = {
  class: "block"
};
const _hoisted_32 = {
  class: "block"
};
const _hoisted_33 = {
  class: "form-switch"
};
const _hoisted_34 = {
  class: "mt-4 flex justify-end"
};
const _hoisted_35 = ["disabled"];
const _hoisted_36 = {
  key: 2,
  class: "grid gap-5 xl:grid-cols-[minmax(0,1fr)_minmax(320px,420px)]"
};
const _hoisted_37 = {
  class: "rounded-xl border border-amber-200 bg-gradient-to-br from-amber-50 to-yellow-50 px-5 py-5 shadow-sm"
};
const _hoisted_38 = {
  class: "flex items-center gap-3"
};
const _hoisted_39 = {
  class: "flex h-10 w-10 items-center justify-center rounded-lg bg-amber-100"
};
const _hoisted_40 = {
  class: "mt-4 space-y-4"
};
const _hoisted_41 = {
  class: "block"
};
const _hoisted_42 = {
  key: 0,
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_43 = {
  class: "block"
};
const _hoisted_44 = {
  class: "block"
};
const _hoisted_45 = {
  class: "mt-4 flex justify-end"
};
const _hoisted_46 = ["disabled"];
const _hoisted_47 = {
  key: 3,
  class: "rounded-xl border border-slate-200 bg-white p-5 shadow-sm"
};
const _hoisted_48 = {
  class: "flex items-center gap-3"
};
const _hoisted_49 = {
  class: "flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50"
};
const _hoisted_50 = {
  class: "mt-5 flex flex-wrap items-end gap-3"
};
const _hoisted_51 = {
  class: "block w-full max-w-xs"
};
const _hoisted_52 = {
  key: 0,
  class: "fixed inset-0 z-50",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "新增报送规则"
};
const _hoisted_53 = {
  class: "absolute inset-y-0 right-0 flex h-full w-full flex-col bg-white shadow-2xl md:w-[540px]"
};
const _hoisted_54 = {
  class: "flex shrink-0 items-center justify-between border-b border-slate-200 px-5 py-4"
};
const _hoisted_55 = {
  class: "flex items-center gap-3"
};
const _hoisted_56 = {
  class: "flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50"
};
const _hoisted_57 = {
  class: "space-y-4"
};
const _hoisted_58 = {
  class: "block"
};
const _hoisted_59 = {
  key: 0,
  class: "block"
};
const _hoisted_60 = {
  class: "form-label"
};
const _hoisted_61 = {
  key: 2,
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_62 = {
  class: "grid gap-4 sm:grid-cols-2"
};
const _hoisted_63 = {
  class: "block"
};
const _hoisted_64 = {
  class: "grid gap-4 sm:grid-cols-2"
};
const _hoisted_65 = {
  class: "block"
};
const _hoisted_66 = {
  class: "block"
};
const _hoisted_67 = {
  class: "grid gap-4 sm:grid-cols-2"
};
const _hoisted_68 = {
  class: "block"
};
const _hoisted_69 = {
  class: "block"
};
const _hoisted_70 = {
  class: "rounded-lg border border-slate-200 bg-white px-3 py-3"
};
const _hoisted_71 = {
  class: "form-switch"
};
const _hoisted_72 = {
  class: "grid gap-4 sm:grid-cols-2"
};
const _hoisted_73 = {
  class: "rounded-lg border border-slate-200 bg-white px-3 py-3"
};
const _hoisted_74 = {
  class: "form-switch"
};
const _hoisted_75 = {
  class: "mt-3 block"
};
const _hoisted_76 = ["disabled"];
const _hoisted_77 = {
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_78 = {
  class: "rounded-lg border border-slate-200 bg-white px-3 py-3"
};
const _hoisted_79 = {
  class: "form-switch"
};
const _hoisted_80 = {
  class: "mt-3 block"
};
const _hoisted_81 = ["disabled"];
const _hoisted_82 = {
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_83 = {
  class: "mt-6 flex justify-end gap-3 border-t border-slate-200 pt-5"
};
const _hoisted_84 = ["disabled"];
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { ArrowTopRightOnSquareIcon, CheckBadgeIcon, ClipboardDocumentCheckIcon, ExclamationTriangleIcon, InboxIcon, PlusIcon, ShieldExclamationIcon, XMarkIcon } from '@heroicons/vue/24/outline';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import UserSelector from '@/components/UserSelector/index.vue';
import DeptSelector from '@/components/DeptSelector/index.vue';
import { getWorkReportRules, saveForcedReportRecipients, saveWorkReportManualExemption, saveWorkReportRules } from '@/api/workReport';
import { isValidDateRange, isValidDeadlineTime, parsePositiveIntegerId } from './composables/workReportGovernanceValidation.mjs';
export default {
  __name: 'WorkReportRuleManagement',
  setup(__props) {
    const router = useRouter();
    const tabs = [{
      value: 'rules',
      label: '报送规则'
    }, {
      value: 'forcedRecipients',
      label: '强制接收人'
    }, {
      value: 'exemptions',
      label: '人工豁免'
    }, {
      value: 'quality',
      label: '组织数据质量'
    }];
    const activeTab = ref('rules');
    const rules = ref([]);
    const rulesLoading = ref(false);
    const rulesLoadError = ref(false);
    const ruleFilter = reactive({
      scope: ''
    });
    const ruleDrawerVisible = ref(false);
    const ruleSubmitting = ref(false);
    const exemptionSubmitting = ref(false);
    const forcedRecipientSubmitting = ref(false);
    const ruleForm = reactive(defaultRuleForm());
    const exemptionForm = reactive(defaultExemptionForm());
    const forcedRecipientForm = reactive(defaultForcedRecipientForm());
    const qualityForm = reactive({
      deptId: ''
    });
    const selectedRuleDept = ref(null);
    const selectedRuleEmployee = ref(null);
    const selectedExemptionEmployee = ref(null);
    const selectedForcedScopeDept = ref(null);
    const selectedForcedScopeEmployee = ref(null);
    const selectedForcedRecipientUser = ref(null);
    const filteredRules = computed(() => {
      if (!ruleFilter.scope) return rules.value;
      return rules.value.filter(rule => String(rule.scope || '').toUpperCase() === ruleFilter.scope);
    });
    onMounted(() => {
      loadRules();
    });
    watch(() => ruleForm.scope, () => {
      ruleForm.scopeTargetId = '';
      selectedRuleDept.value = null;
      selectedRuleEmployee.value = null;
    });
    watch(() => forcedRecipientForm.scope, () => {
      forcedRecipientForm.scopeTargetId = '';
      selectedForcedScopeDept.value = null;
      selectedForcedScopeEmployee.value = null;
    });
    async function loadRules() {
      rulesLoading.value = true;
      rulesLoadError.value = false;
      try {
        rules.value = normalizeRules(await getWorkReportRules());
      } catch {
        rules.value = [];
        rulesLoadError.value = true;
      } finally {
        rulesLoading.value = false;
      }
    }
    function normalizeRules(data) {
      if (Array.isArray(data)) return data;
      if (Array.isArray(data?.records)) return data.records;
      if (Array.isArray(data?.list)) return data.list;
      if (Array.isArray(data?.items)) return data.items;
      if (Array.isArray(data?.rules)) return data.rules;
      return [];
    }
    function resetRuleFilter() {
      ruleFilter.scope = '';
    }
    function openRuleDrawer() {
      Object.assign(ruleForm, defaultRuleForm());
      selectedRuleDept.value = null;
      selectedRuleEmployee.value = null;
      ruleDrawerVisible.value = true;
    }
    function closeRuleDrawer() {
      if (!ruleSubmitting.value) ruleDrawerVisible.value = false;
    }
    async function submitRule() {
      if (!ruleForm.versionNo || !ruleForm.effectiveFrom) {
        ElMessage.warning('请填写版本号和生效日期');
        return;
      }
      if (!isValidDateRange(ruleForm.effectiveFrom, ruleForm.effectiveTo)) {
        ElMessage.warning('生效日期不能晚于失效日期');
        return;
      }
      if (!isValidDeadlineTime(ruleForm.planDeadline) || !isValidDeadlineTime(ruleForm.summaryDeadline)) {
        ElMessage.warning('请填写有效的截止时间');
        return;
      }
      if (ruleForm.teamPlanReminderEnabled && !Number.isInteger(Number(ruleForm.teamPlanReminderOffsetMinutes))) {
        ElMessage.warning('请填写有效的团队计划提醒时间');
        return;
      }
      if (ruleForm.teamSummaryReminderEnabled && !Number.isInteger(Number(ruleForm.teamSummaryReminderOffsetMinutes))) {
        ElMessage.warning('请填写有效的团队总结提醒时间');
        return;
      }
      const scopeTargetId = ruleForm.scope === 'TENANT' ? null : parsePositiveIntegerId(ruleForm.scopeTargetId);
      if (ruleForm.scope !== 'TENANT' && scopeTargetId === null) {
        ElMessage.warning(ruleForm.scope === 'DEPARTMENT' ? '请输入有效部门 ID' : '请输入有效员工 ID');
        return;
      }
      ruleSubmitting.value = true;
      try {
        await saveWorkReportRules({
          versionNo: Number(ruleForm.versionNo),
          scope: ruleForm.scope,
          scopeTargetId,
          effectiveFrom: ruleForm.effectiveFrom,
          effectiveTo: ruleForm.effectiveTo || null,
          planDeadline: ruleForm.planDeadline || null,
          summaryDeadline: ruleForm.summaryDeadline || null,
          dailyReportEnabled: ruleForm.dailyReportEnabled !== false,
          teamPlanReminderEnabled: ruleForm.teamPlanReminderEnabled === true,
          teamPlanReminderOffsetMinutes: ruleForm.teamPlanReminderEnabled ? Number(ruleForm.teamPlanReminderOffsetMinutes) : null,
          teamSummaryReminderEnabled: ruleForm.teamSummaryReminderEnabled === true,
          teamSummaryReminderOffsetMinutes: ruleForm.teamSummaryReminderEnabled ? Number(ruleForm.teamSummaryReminderOffsetMinutes) : null
        });
        ElMessage.success('报送规则已保存');
        ruleDrawerVisible.value = false;
        await loadRules();
      } catch {
        ElMessage.error('报送规则保存失败，请稍后重试');
      } finally {
        ruleSubmitting.value = false;
      }
    }
    async function submitExemption() {
      if (!exemptionForm.employeeUserId || !exemptionForm.exemptionDate || !exemptionForm.reason) {
        ElMessage.warning('请填写员工、日期和原因');
        return;
      }
      const employeeUserId = parsePositiveIntegerId(exemptionForm.employeeUserId);
      if (employeeUserId === null) {
        ElMessage.warning('请输入有效员工用户 ID');
        return;
      }
      exemptionSubmitting.value = true;
      try {
        await saveWorkReportManualExemption({
          employeeUserId,
          exemptionDate: exemptionForm.exemptionDate,
          reason: exemptionForm.reason
        });
        ElMessage.success('人工豁免已创建');
        Object.assign(exemptionForm, defaultExemptionForm());
        selectedExemptionEmployee.value = null;
      } catch {
        ElMessage.error('人工豁免创建失败，请稍后重试');
      } finally {
        exemptionSubmitting.value = false;
      }
    }
    async function submitForcedRecipient() {
      const scopeTargetId = forcedRecipientForm.scope === 'TENANT' ? null : parsePositiveIntegerId(forcedRecipientForm.scopeTargetId);
      const userId = parsePositiveIntegerId(forcedRecipientForm.userId);
      if (forcedRecipientForm.scope !== 'TENANT' && scopeTargetId === null) {
        ElMessage.warning(forcedRecipientForm.scope === 'DEPARTMENT' ? '请选择有效部门' : '请选择有效员工');
        return;
      }
      if (userId === null) {
        ElMessage.warning('请选择有效接收人');
        return;
      }
      forcedRecipientSubmitting.value = true;
      try {
        await saveForcedReportRecipients({
          scope: forcedRecipientForm.scope,
          scopeTargetId,
          userId,
          role: forcedRecipientForm.role,
          active: forcedRecipientForm.active
        });
        ElMessage.success('强制接收人已保存');
        Object.assign(forcedRecipientForm, defaultForcedRecipientForm());
        selectedForcedScopeDept.value = null;
        selectedForcedScopeEmployee.value = null;
        selectedForcedRecipientUser.value = null;
      } catch {
        ElMessage.error('强制接收人保存失败，请稍后重试');
      } finally {
        forcedRecipientSubmitting.value = false;
      }
    }
    function goDepartmentManagement() {
      router.push({
        path: '/system/dept',
        query: qualityForm.deptId ? {
          deptId: qualityForm.deptId
        } : {}
      });
    }
    function handleRuleDeptChange(value) {
      selectedRuleDept.value = value;
      ruleForm.scopeTargetId = normalizeSelectorId(value);
    }
    function handleRuleEmployeeConfirm(users) {
      const [user] = Array.isArray(users) ? users : [];
      selectedRuleEmployee.value = user || null;
      ruleForm.scopeTargetId = normalizeSelectorId(user || selectedRuleEmployee.value);
    }
    function handleRuleEmployeeChange(value) {
      selectedRuleEmployee.value = value;
      ruleForm.scopeTargetId = normalizeSelectorId(value);
    }
    function handleExemptionEmployeeConfirm(users) {
      const [user] = Array.isArray(users) ? users : [];
      selectedExemptionEmployee.value = user || null;
      exemptionForm.employeeUserId = normalizeSelectorId(user || selectedExemptionEmployee.value);
    }
    function handleExemptionEmployeeChange(value) {
      selectedExemptionEmployee.value = value;
      exemptionForm.employeeUserId = normalizeSelectorId(value);
    }
    function handleForcedScopeDeptChange(value) {
      selectedForcedScopeDept.value = value;
      forcedRecipientForm.scopeTargetId = normalizeSelectorId(value);
    }
    function handleForcedScopeEmployeeConfirm(users) {
      const [user] = Array.isArray(users) ? users : [];
      selectedForcedScopeEmployee.value = user || null;
      forcedRecipientForm.scopeTargetId = normalizeSelectorId(user || selectedForcedScopeEmployee.value);
    }
    function handleForcedScopeEmployeeChange(value) {
      selectedForcedScopeEmployee.value = value;
      forcedRecipientForm.scopeTargetId = normalizeSelectorId(value);
    }
    function handleForcedRecipientUserConfirm(users) {
      const [user] = Array.isArray(users) ? users : [];
      selectedForcedRecipientUser.value = user || null;
      forcedRecipientForm.userId = normalizeSelectorId(user || selectedForcedRecipientUser.value);
    }
    function handleForcedRecipientUserChange(value) {
      selectedForcedRecipientUser.value = value;
      forcedRecipientForm.userId = normalizeSelectorId(value);
    }
    function normalizeSelectorId(value) {
      if (Array.isArray(value)) return normalizeSelectorId(value[0]);
      if (value && typeof value === 'object') return value.id ?? '';
      return value || '';
    }
    function defaultRuleForm() {
      return {
        scope: 'TENANT',
        scopeTargetId: '',
        versionNo: 1,
        effectiveFrom: localDate(),
        effectiveTo: '',
        planDeadline: '09:30',
        summaryDeadline: '18:30',
        dailyReportEnabled: true,
        teamPlanReminderEnabled: false,
        teamPlanReminderOffsetMinutes: -30,
        teamSummaryReminderEnabled: false,
        teamSummaryReminderOffsetMinutes: -20
      };
    }
    function defaultExemptionForm() {
      return {
        employeeUserId: '',
        exemptionDate: localDate(),
        reason: ''
      };
    }
    function defaultForcedRecipientForm() {
      return {
        scope: 'TENANT',
        scopeTargetId: '',
        userId: '',
        role: 'FORCED_RECIPIENT',
        active: true
      };
    }
    function scopeLabel(scope) {
      const normalized = String(scope || '').toUpperCase();
      if (normalized === 'TENANT') return '租户默认';
      if (normalized === 'DEPARTMENT') return '部门';
      if (normalized === 'EMPLOYEE') return '员工';
      return scope || '--';
    }
    function scopeTargetLabel(rule) {
      if (String(rule?.scope || '').toUpperCase() === 'TENANT') return '全租户';
      return rule?.scopeTargetName || rule?.targetName || rule?.scopeTargetId || '--';
    }
    function dateRangeLabel(rule) {
      const from = rule?.effectiveFrom || '--';
      const to = rule?.effectiveTo || '长期有效';
      return `${from} 至 ${to}`;
    }
    function timeLabel(value) {
      if (!value) return '--';
      return String(value).slice(0, 5);
    }
    function reminderOffsetLabel(enabled, offset) {
      if (!enabled) return '未开启';
      const value = Number(offset);
      if (!Number.isFinite(value)) return '已开启';
      if (value === 0) return '截止时';
      return value < 0 ? `截止前 ${Math.abs(value)} 分钟` : `截止后 ${value} 分钟`;
    }
    function localDate() {
      const now = new Date();
      const offset = now.getTimezoneOffset();
      return new Date(now.getTime() - offset * 60 * 1000).toISOString().slice(0, 10);
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_modal_a11y = _resolveDirective("modal-a11y");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "日报治理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "维护报送规则、创建人工豁免，并识别组织数据对日报流转的影响。")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("nav", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, tab => {
          return _createElementVNode("button", {
            key: tab.value,
            type: "button",
            class: _normalizeClass(["rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200", activeTab.value === tab.value ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700']),
            onClick: $event => activeTab.value = tab.value
          }, _toDisplayString(tab.label), 11, _hoisted_3);
        }), 64))]), activeTab.value === 'rules' ? (_openBlock(), _createElementBlock("section", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": rulesLoading.value,
          onRefresh: loadRules
        }, {
          searchActionsLeading: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: openRuleDrawer
          }, [_createVNode(_unref(PlusIcon), {
            class: "h-4 w-4"
          }), _cache[25] || (_cache[25] = _createTextVNode(" 新增规则 ", -1))])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: rulesLoading.value,
            onClick: resetRuleFilter
          }, "重置", 8, _hoisted_6)]),
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: ruleFilter.scope,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ruleFilter.scope = $event),
            placeholder: "请选择范围",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部范围",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "租户默认",
              value: "TENANT"
            }), _createVNode(_component_el_option, {
              label: "部门",
              value: "DEPARTMENT"
            }), _createVNode(_component_el_option, {
              label: "员工",
              value: "EMPLOYEE"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_7, [rulesLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[26] || (_cache[26] = [_createElementVNode("div", {
          class: "app-spinner"
        }, null, -1), _createElementVNode("span", {
          class: "text-sm text-slate-500"
        }, "正在加载报送规则...", -1)]))])) : rulesLoadError.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_unref(ExclamationTriangleIcon), {
          class: "h-6 w-6 text-rose-500"
        })]), _cache[27] || (_cache[27] = _createElementVNode("p", {
          class: "text-sm text-slate-600"
        }, "报送规则加载失败，请稍后重试。", -1)), _createElementVNode("button", {
          type: "button",
          class: "btn-secondary mt-1",
          onClick: loadRules
        }, "重试")])) : filteredRules.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_unref(InboxIcon), {
          class: "h-6 w-6 text-slate-400"
        })]), _cache[28] || (_cache[28] = _createElementVNode("span", {
          class: "empty-state-title"
        }, "暂无报送规则", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("table", _hoisted_14, [_cache[29] || (_cache[29] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "范围"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "目标"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "版本"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "生效区间"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "日报功能"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "计划截止"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "计划提醒"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "总结截止"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "总结提醒"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "状态")])], -1)), _createElementVNode("tbody", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredRules.value, rule => {
          return _openBlock(), _createElementBlock("tr", {
            key: rule.id || `${rule.scope}-${rule.scopeTargetId}-${rule.versionNo}`,
            class: "transition-colors hover:bg-slate-50/80"
          }, [_createElementVNode("td", _hoisted_16, _toDisplayString(scopeLabel(rule.scope)), 1), _createElementVNode("td", _hoisted_17, _toDisplayString(scopeTargetLabel(rule)), 1), _createElementVNode("td", _hoisted_18, "v" + _toDisplayString(rule.versionNo || '--'), 1), _createElementVNode("td", _hoisted_19, _toDisplayString(dateRangeLabel(rule)), 1), _createElementVNode("td", _hoisted_20, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", rule.dailyReportEnabled === false ? 'bg-slate-100 text-slate-600' : 'bg-emerald-50 text-emerald-700'])
          }, _toDisplayString(rule.dailyReportEnabled === false ? '关闭' : '开启'), 3)]), _createElementVNode("td", _hoisted_21, _toDisplayString(timeLabel(rule.planDeadline)), 1), _createElementVNode("td", _hoisted_22, _toDisplayString(reminderOffsetLabel(rule.teamPlanReminderEnabled, rule.teamPlanReminderOffsetMinutes)), 1), _createElementVNode("td", _hoisted_23, _toDisplayString(timeLabel(rule.summaryDeadline)), 1), _createElementVNode("td", _hoisted_24, _toDisplayString(reminderOffsetLabel(rule.teamSummaryReminderEnabled, rule.teamSummaryReminderOffsetMinutes)), 1), _createElementVNode("td", _hoisted_25, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", rule.active === false ? 'bg-slate-100 text-slate-600' : 'bg-emerald-50 text-emerald-700'])
          }, _toDisplayString(rule.active === false ? '停用' : '启用'), 3)])]);
        }), 128))])])]))])])])) : activeTab.value === 'forcedRecipients' ? (_openBlock(), _createElementBlock("section", _hoisted_26, [_cache[37] || (_cache[37] = _createElementVNode("div", {
          class: "rounded-xl border border-blue-200 bg-blue-50 px-5 py-5 shadow-sm"
        }, [_createElementVNode("h2", {
          class: "text-base font-semibold text-blue-900"
        }, "强制接收人"), _createElementVNode("p", {
          class: "mt-3 text-sm leading-6 text-blue-700"
        }, " 为租户、部门或员工配置强制接收人/抄送人。日报生成时由后端按规则写入接收人快照。 ")], -1)), _createElementVNode("form", {
          class: "rounded-xl border border-slate-200 bg-white p-5 shadow-sm",
          onSubmit: _withModifiers(submitForcedRecipient, ["prevent"])
        }, [_cache[36] || (_cache[36] = _createElementVNode("h3", {
          class: "text-base font-semibold text-slate-900"
        }, "新增强制接收人", -1)), _createElementVNode("div", _hoisted_27, [_createElementVNode("label", _hoisted_28, [_cache[30] || (_cache[30] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("范围 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(_component_el_select, {
          modelValue: forcedRecipientForm.scope,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => forcedRecipientForm.scope = $event),
          class: "form-select mt-1 w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "租户默认",
            value: "TENANT"
          }), _createVNode(_component_el_option, {
            label: "部门",
            value: "DEPARTMENT"
          }), _createVNode(_component_el_option, {
            label: "员工",
            value: "EMPLOYEE"
          })]),
          _: 1
        }, 8, ["modelValue"])]), forcedRecipientForm.scope !== 'TENANT' ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("span", _hoisted_30, [_createTextVNode(_toDisplayString(forcedRecipientForm.scope === 'DEPARTMENT' ? '部门' : '员工') + " ", 1), _cache[31] || (_cache[31] = _createElementVNode("span", {
          class: "text-red-500"
        }, "*", -1))]), forcedRecipientForm.scope === 'DEPARTMENT' ? (_openBlock(), _createBlock(DeptSelector, {
          key: 0,
          modelValue: selectedForcedScopeDept.value,
          "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => selectedForcedScopeDept.value = $event), handleForcedScopeDeptChange],
          class: "mt-1",
          multiple: false,
          placeholder: "请选择作用部门"
        }, null, 8, ["modelValue"])) : (_openBlock(), _createBlock(UserSelector, {
          key: 1,
          modelValue: selectedForcedScopeEmployee.value,
          "onUpdate:modelValue": [_cache[3] || (_cache[3] = $event => selectedForcedScopeEmployee.value = $event), handleForcedScopeEmployeeChange],
          class: "mt-1",
          multiple: false,
          placeholder: "请选择作用员工",
          onConfirm: handleForcedScopeEmployeeConfirm
        }, null, 8, ["modelValue"]))])) : _createCommentVNode("", true), _createElementVNode("label", _hoisted_31, [_cache[32] || (_cache[32] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("接收人 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(UserSelector, {
          modelValue: selectedForcedRecipientUser.value,
          "onUpdate:modelValue": [_cache[4] || (_cache[4] = $event => selectedForcedRecipientUser.value = $event), handleForcedRecipientUserChange],
          class: "mt-1",
          multiple: false,
          placeholder: "请选择接收人",
          onConfirm: handleForcedRecipientUserConfirm
        }, null, 8, ["modelValue"])]), _createElementVNode("label", _hoisted_32, [_cache[33] || (_cache[33] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("角色 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(_component_el_select, {
          modelValue: forcedRecipientForm.role,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => forcedRecipientForm.role = $event),
          class: "form-select mt-1 w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "强制接收人",
            value: "FORCED_RECIPIENT"
          }), _createVNode(_component_el_option, {
            label: "强制抄送人",
            value: "FORCED_CC"
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("label", _hoisted_33, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => forcedRecipientForm.active = $event),
          class: "form-switch-input",
          type: "checkbox"
        }, null, 512), [[_vModelCheckbox, forcedRecipientForm.active]]), _cache[34] || (_cache[34] = _createElementVNode("span", {
          class: "form-switch-track"
        }, null, -1)), _cache[35] || (_cache[35] = _createElementVNode("span", {
          class: "form-switch-label"
        }, "启用", -1))])]), _createElementVNode("div", _hoisted_34, [_createElementVNode("button", {
          type: "submit",
          class: "btn-primary",
          disabled: forcedRecipientSubmitting.value
        }, _toDisplayString(forcedRecipientSubmitting.value ? '保存中' : '保存强制接收人'), 9, _hoisted_35)])], 32)])) : activeTab.value === 'exemptions' ? (_openBlock(), _createElementBlock("section", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createVNode(_unref(ShieldExclamationIcon), {
          class: "h-5 w-5 text-amber-600"
        })]), _cache[38] || (_cache[38] = _createElementVNode("h2", {
          class: "text-base font-semibold text-amber-900"
        }, "人工豁免", -1))]), _cache[39] || (_cache[39] = _createElementVNode("p", {
          class: "mt-3 text-sm leading-6 text-amber-700"
        }, " 当前接口仅支持新增人工豁免。豁免列表与撤销待后端能力提供后启用；若日报已生成，由后端负责刷新资格事实。 ", -1))]), _createElementVNode("form", {
          class: "rounded-xl border border-slate-200 bg-white p-5 shadow-sm",
          onSubmit: _withModifiers(submitExemption, ["prevent"])
        }, [_cache[43] || (_cache[43] = _createElementVNode("h3", {
          class: "text-base font-semibold text-slate-900"
        }, "新增豁免", -1)), _createElementVNode("div", _hoisted_40, [_createElementVNode("label", _hoisted_41, [_cache[40] || (_cache[40] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("员工 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(UserSelector, {
          modelValue: selectedExemptionEmployee.value,
          "onUpdate:modelValue": [_cache[7] || (_cache[7] = $event => selectedExemptionEmployee.value = $event), handleExemptionEmployeeChange],
          class: "mt-1",
          multiple: false,
          placeholder: "请选择豁免员工",
          onConfirm: handleExemptionEmployeeConfirm
        }, null, 8, ["modelValue"]), exemptionForm.employeeUserId ? (_openBlock(), _createElementBlock("p", _hoisted_42, "员工 ID：" + _toDisplayString(exemptionForm.employeeUserId), 1)) : _createCommentVNode("", true)]), _createElementVNode("label", _hoisted_43, [_cache[41] || (_cache[41] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("豁免日期 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => exemptionForm.exemptionDate = $event),
          class: "form-input form-date mt-1 w-full",
          type: "date"
        }, null, 512), [[_vModelText, exemptionForm.exemptionDate]])]), _createElementVNode("label", _hoisted_44, [_cache[42] || (_cache[42] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("原因 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => exemptionForm.reason = $event),
          class: "form-textarea mt-1 w-full",
          rows: "4",
          placeholder: "请输入豁免原因"
        }, null, 512), [[_vModelText, exemptionForm.reason, void 0, {
          trim: true
        }]])])]), _createElementVNode("div", _hoisted_45, [_createElementVNode("button", {
          type: "submit",
          class: "btn-primary",
          disabled: exemptionSubmitting.value
        }, _toDisplayString(exemptionSubmitting.value ? '提交中' : '创建豁免'), 9, _hoisted_46)])], 32)])) : (_openBlock(), _createElementBlock("section", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createVNode(_unref(CheckBadgeIcon), {
          class: "h-5 w-5 text-blue-600"
        })]), _cache[44] || (_cache[44] = _createElementVNode("div", null, [_createElementVNode("h2", {
          class: "text-base font-semibold text-slate-900"
        }, "组织数据质量")], -1))]), _cache[47] || (_cache[47] = _createElementVNode("div", {
          class: "mt-4 max-w-3xl"
        }, [_createElementVNode("p", {
          class: "mt-2 text-sm leading-6 text-slate-600"
        }, " 未配置负责人的部门属于非阻断异常：员工仍可提交日报，但不会产生主管接收或评价任务；负责人补齐后不回填既有日报事实。 "), _createElementVNode("p", {
          class: "mt-2 text-sm leading-6 text-slate-600"
        }, " 负责人缺失列表接口未就绪，因此不展示影响数列表。请前往部门管理维护负责人信息。 ")], -1)), _createElementVNode("div", _hoisted_50, [_createElementVNode("label", _hoisted_51, [_cache[45] || (_cache[45] = _createElementVNode("span", {
          class: "form-label"
        }, "部门 ID（可选）", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => qualityForm.deptId = $event),
          class: "form-input form-control-sm mt-1 w-full",
          inputmode: "numeric",
          placeholder: "带入部门管理筛选"
        }, null, 512), [[_vModelText, qualityForm.deptId, void 0, {
          trim: true
        }]])]), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          onClick: goDepartmentManagement
        }, [_createVNode(_unref(ArrowTopRightOnSquareIcon), {
          class: "h-4 w-4"
        }), _cache[46] || (_cache[46] = _createTextVNode(" 前往部门管理 ", -1))])])]))]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [ruleDrawerVisible.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_52, [_createElementVNode("div", {
          class: "absolute inset-0 bg-slate-900/60 backdrop-blur-sm",
          onClick: closeRuleDrawer
        }), _createElementVNode("aside", _hoisted_53, [_createElementVNode("header", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createVNode(_unref(ClipboardDocumentCheckIcon), {
          class: "h-5 w-5 text-blue-600"
        })]), _cache[48] || (_cache[48] = _createElementVNode("div", null, [_createElementVNode("h2", {
          class: "text-lg font-semibold text-slate-900"
        }, "新增报送规则"), _createElementVNode("p", {
          class: "mt-0.5 text-sm text-slate-500"
        }, "保存后由后端完成重叠校验和规则生效判断。")], -1))]), _createElementVNode("button", {
          type: "button",
          class: "rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600",
          title: "关闭",
          "aria-label": "关闭",
          onClick: closeRuleDrawer
        }, [_createVNode(_unref(XMarkIcon), {
          class: "h-5 w-5"
        })])]), _createElementVNode("form", {
          class: "min-h-0 flex-1 overflow-y-auto bg-slate-50 px-5 py-5",
          onSubmit: _withModifiers(submitRule, ["prevent"])
        }, [_createElementVNode("div", _hoisted_57, [_createElementVNode("label", _hoisted_58, [_cache[49] || (_cache[49] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("范围 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(_component_el_select, {
          modelValue: ruleForm.scope,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ruleForm.scope = $event),
          class: "form-select mt-1 w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "租户默认",
            value: "TENANT"
          }), _createVNode(_component_el_option, {
            label: "部门",
            value: "DEPARTMENT"
          }), _createVNode(_component_el_option, {
            label: "员工",
            value: "EMPLOYEE"
          })]),
          _: 1
        }, 8, ["modelValue"])]), ruleForm.scope !== 'TENANT' ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_createElementVNode("span", _hoisted_60, [_createTextVNode(_toDisplayString(ruleForm.scope === 'DEPARTMENT' ? '部门' : '员工') + " ", 1), _cache[50] || (_cache[50] = _createElementVNode("span", {
          class: "text-red-500"
        }, "*", -1))]), ruleForm.scope === 'DEPARTMENT' ? (_openBlock(), _createBlock(DeptSelector, {
          key: 0,
          modelValue: selectedRuleDept.value,
          "onUpdate:modelValue": [_cache[12] || (_cache[12] = $event => selectedRuleDept.value = $event), handleRuleDeptChange],
          class: "mt-1",
          multiple: false,
          placeholder: "请选择适用部门"
        }, null, 8, ["modelValue"])) : (_openBlock(), _createBlock(UserSelector, {
          key: 1,
          modelValue: selectedRuleEmployee.value,
          "onUpdate:modelValue": [_cache[13] || (_cache[13] = $event => selectedRuleEmployee.value = $event), handleRuleEmployeeChange],
          class: "mt-1",
          multiple: false,
          placeholder: "请选择适用员工",
          onConfirm: handleRuleEmployeeConfirm
        }, null, 8, ["modelValue"])), ruleForm.scopeTargetId ? (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString(ruleForm.scope === 'DEPARTMENT' ? '部门 ID' : '员工 ID') + "：" + _toDisplayString(ruleForm.scopeTargetId), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_62, [_createElementVNode("label", _hoisted_63, [_cache[51] || (_cache[51] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("版本号 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ruleForm.versionNo = $event),
          class: "form-input mt-1 w-full",
          type: "number",
          min: "1"
        }, null, 512), [[_vModelText, ruleForm.versionNo, void 0, {
          number: true
        }]])])]), _createElementVNode("div", _hoisted_64, [_createElementVNode("label", _hoisted_65, [_cache[52] || (_cache[52] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("生效日期 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ruleForm.effectiveFrom = $event),
          class: "form-input form-date mt-1 w-full",
          type: "date"
        }, null, 512), [[_vModelText, ruleForm.effectiveFrom]])]), _createElementVNode("label", _hoisted_66, [_cache[53] || (_cache[53] = _createElementVNode("span", {
          class: "form-label"
        }, "失效日期", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ruleForm.effectiveTo = $event),
          class: "form-input form-date mt-1 w-full",
          type: "date"
        }, null, 512), [[_vModelText, ruleForm.effectiveTo]])])]), _createElementVNode("div", _hoisted_67, [_createElementVNode("label", _hoisted_68, [_cache[54] || (_cache[54] = _createElementVNode("span", {
          class: "form-label"
        }, "计划截止", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => ruleForm.planDeadline = $event),
          class: "form-input mt-1 w-full",
          type: "time"
        }, null, 512), [[_vModelText, ruleForm.planDeadline]])]), _createElementVNode("label", _hoisted_69, [_cache[55] || (_cache[55] = _createElementVNode("span", {
          class: "form-label"
        }, "总结截止", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ruleForm.summaryDeadline = $event),
          class: "form-input mt-1 w-full",
          type: "time"
        }, null, 512), [[_vModelText, ruleForm.summaryDeadline]])])]), _createElementVNode("div", _hoisted_70, [_createElementVNode("label", _hoisted_71, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => ruleForm.dailyReportEnabled = $event),
          class: "form-switch-input",
          type: "checkbox"
        }, null, 512), [[_vModelCheckbox, ruleForm.dailyReportEnabled]]), _cache[56] || (_cache[56] = _createElementVNode("span", {
          class: "form-switch-track"
        }, null, -1)), _cache[57] || (_cache[57] = _createElementVNode("span", {
          class: "form-switch-label"
        }, "开启日报要求", -1))]), _cache[58] || (_cache[58] = _createElementVNode("p", {
          class: "mt-1 text-xs leading-5 text-slate-500"
        }, "关闭后不计入团队应交和团队提醒，员工仍可主动提交日报。", -1))]), _createElementVNode("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, [_createElementVNode("label", _hoisted_74, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => ruleForm.teamPlanReminderEnabled = $event),
          class: "form-switch-input",
          type: "checkbox"
        }, null, 512), [[_vModelCheckbox, ruleForm.teamPlanReminderEnabled]]), _cache[59] || (_cache[59] = _createElementVNode("span", {
          class: "form-switch-track"
        }, null, -1)), _cache[60] || (_cache[60] = _createElementVNode("span", {
          class: "form-switch-label"
        }, "团队计划提醒", -1))]), _createElementVNode("label", _hoisted_75, [_cache[61] || (_cache[61] = _createElementVNode("span", {
          class: "form-label"
        }, "相对计划截止（分钟）", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => ruleForm.teamPlanReminderOffsetMinutes = $event),
          class: "form-input mt-1 w-full",
          type: "number",
          disabled: !ruleForm.teamPlanReminderEnabled
        }, null, 8, _hoisted_76), [[_vModelText, ruleForm.teamPlanReminderOffsetMinutes, void 0, {
          number: true
        }]])]), _createElementVNode("p", _hoisted_77, _toDisplayString(reminderOffsetLabel(ruleForm.teamPlanReminderEnabled, ruleForm.teamPlanReminderOffsetMinutes)), 1)]), _createElementVNode("div", _hoisted_78, [_createElementVNode("label", _hoisted_79, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => ruleForm.teamSummaryReminderEnabled = $event),
          class: "form-switch-input",
          type: "checkbox"
        }, null, 512), [[_vModelCheckbox, ruleForm.teamSummaryReminderEnabled]]), _cache[62] || (_cache[62] = _createElementVNode("span", {
          class: "form-switch-track"
        }, null, -1)), _cache[63] || (_cache[63] = _createElementVNode("span", {
          class: "form-switch-label"
        }, "团队总结提醒", -1))]), _createElementVNode("label", _hoisted_80, [_cache[64] || (_cache[64] = _createElementVNode("span", {
          class: "form-label"
        }, "相对总结截止（分钟）", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => ruleForm.teamSummaryReminderOffsetMinutes = $event),
          class: "form-input mt-1 w-full",
          type: "number",
          disabled: !ruleForm.teamSummaryReminderEnabled
        }, null, 8, _hoisted_81), [[_vModelText, ruleForm.teamSummaryReminderOffsetMinutes, void 0, {
          number: true
        }]])]), _createElementVNode("p", _hoisted_82, _toDisplayString(reminderOffsetLabel(ruleForm.teamSummaryReminderEnabled, ruleForm.teamSummaryReminderOffsetMinutes)), 1)])]), _cache[65] || (_cache[65] = _createElementVNode("p", {
          class: "rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm leading-6 text-amber-800"
        }, " 重叠风险由后端最终判断；规则变更不会重写已经冻结到日报中的规则快照。 ", -1))]), _createElementVNode("div", _hoisted_83, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: closeRuleDrawer
        }, "取消"), _createElementVNode("button", {
          type: "submit",
          class: "btn-primary",
          disabled: ruleSubmitting.value
        }, _toDisplayString(ruleSubmitting.value ? '保存中' : '保存规则'), 9, _hoisted_84)])], 32)])])), [[_directive_modal_a11y, closeRuleDrawer]]) : _createCommentVNode("", true)]))]),
        _: 1
      });
    };
  }
};